import axios from 'axios'
import router from './../router'

// Request interceptor to add headers
axios.interceptors.request.use(
    (config) => {
        // Only intercept requests to our API
        const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
        if (config.url && apiBaseUrl && config.url.startsWith(apiBaseUrl)) {
            const member = JSON.parse(localStorage.getItem('authUser'));
            const token = localStorage.getItem('token') || localStorage.getItem('id_token');
            const communityId = localStorage.getItem('community_id');

            // Set default headers (only if not already set by component)
            config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
            
            // These headers are always set/overwritten by interceptor to ensure consistency
            if (token) {
                config.headers['x-access-token'] = token;
            }
            
            if (member && member.memberID) {
                config.headers['x-api-key'] = member.memberID;
            }
            
            if (communityId) {
                config.headers['x-tenant-id'] = communityId;
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
// axios.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response?.status === 401) {
//             localStorage.clear();
//             router.push('/login');
//         }
//         return Promise.reject(error);
//     }
// );

export default axios;
